module.exports = __webpack_public_path__ + "static/media/4A.126e629c.jpg";